export default function Mission() {
  const values = [
    {
      icon: 'ri-target-line',
      title: 'Mission',
      desc: 'To deliver exceptional cleaning and contracting services that exceed customer expectations through individual attention, selective service, and dedicated workmanship. We strive to maintain the highest standards of quality and professionalism in every task we undertake.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Vision',
      desc: 'To be the leading cleaning service provider in the Kingdom of Bahrain, recognized for our excellence, reliability, and commitment to sustainable practices. We aim to set industry standards and build long-lasting partnerships with our clients.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Values',
      desc: 'Professionalism, reliability, sustainability, and excellence guide everything we do. We believe in fair and equitable trade practices, continuous improvement, and building trust through consistent quality service delivery and customer satisfaction.'
    }
  ];

  return (
    <section id="mission" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-20 right-20 w-96 h-96 bg-teal-100 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-orange-100 rounded-full opacity-20 blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-teal-50 rounded-2xl p-10 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${value.icon} text-gray-900 text-6xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{value.title}</h3>
              <div className="w-10 h-0.5 bg-teal-500 mb-6"></div>
              <p className="text-gray-600 leading-relaxed text-sm">{value.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
